import React from 'react';
import {Card} from 'antd';
class Logs extends React.Component {
  render() {
    return <div>
      <Card title="Lịch sử người dùng" bordered={false} className="card"></Card>
    </div>
  }
}
export default Logs



// WEBPACK FOOTER //
// ./src/pages/Logs.js